import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function FinalCTASection() {
  const scrollToForm = () => {
    const el = document.getElementById("application-form");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="final-cta-section" className="py-10 md:py-[85px] bg-white">
      <div className="section-container">
        <div className="relative bg-gradient-to-br from-[#0F172A] to-[#1E293B] rounded-3xl p-10 md:p-16 overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#3B82F6]/10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#3B82F6]/5 rounded-full blur-3xl" />
          
          <div className="relative z-10 text-center max-w-2xl mx-auto">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-white tracking-tight text-balance mb-5">
              Turn Every Call Into a{" "}
              <span className="text-[#3B82F6]">Booked Appointment</span>
            </h2>
            <p className="text-base md:text-lg text-slate-300 leading-relaxed mb-8 max-w-2xl mx-auto">
              Stop losing customers to voicemail. Let your AI receptionist answer every call, capture every lead, and fill your calendar — automatically.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button
                onClick={scrollToForm}
                className="bg-[#3B82F6] text-white h-12 px-8 rounded-lg font-medium hover:bg-blue-600 transition-all shadow-lg hover:shadow-xl group"
                data-testid="final-cta-button"
              >
                Book a Demo
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              <a
                href="mailto:info@aicallfront.com"
                className="text-sm font-medium text-slate-400 hover:text-white transition-colors"
                data-testid="final-cta-contact"
              >
                Or contact us at info@aicallfront.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
